
import React from 'react';
import { Link } from 'react-router-dom';

class KeyMakersBanner extends React.Component {
	render() {
		return ( 
            <section className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="featued-container key-maker">
                            <div className="row">
                                <div className="col-sm-6 col-sm-offset-6">
                                    <div className="featured-wrapper">
                                        <h3>Mangler du ekstra nøgler til din cykel eller bolig?</h3>
                                        <p>En ekstranøgle er altid en god idé at have i reserve. Vi fremstiller gerne duplikatsæt af alle dine cykel- og husnøgler.</p>
                                        <p>Hurtig og professionel service – vi laver dine nye nøgler, mens du venter!</p>
                                        <p>Besøg os i butikken ved Husum Torv – nemt og bekvemt.</p>
                                        <Link to="/contact" className="btn btn-default btn-lg">Kontakt Os / Find Butik</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
	}
}

export default KeyMakersBanner;


// WEBPACK FOOTER //
// ./src/Components/KeyMakersBanner.js